import EditLegalPagesForm from 'components/legalPages/EditLegalPagesForm'
import CommonLayout from 'layouts/DashboardLayout'
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import CareerDetail from 'components/legalPages/DetailsPages/CareerDetail';
import TeamDetail from 'components/legalPages/DetailsPages/TeamDetail';
import AboutDetail from 'components/legalPages/DetailsPages/AboutDetail';
import ReviewDetail from 'components/legalPages/DetailsPages/ReviewDetail';
import AngleRightIcon from 'common/customIcons/angle_right';
import MDButton from 'components/MDButton';
import EditLegalPagesDetails from 'components/legalPages/DetailsPages/EditLegalPagesDetail';
import { useSelector } from 'react-redux';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';
import { getData } from 'utilities/common';
import ZipcodePageDetail from '../../components/legalPages/DetailsPages/ZipcodePageDetail';
import PricingDetail from 'components/legalPages/DetailsPages/PricingDetail';
import DeliveryTimeDetail from 'components/legalPages/DetailsPages/DeliveryTime';
import ServiceGuaranteeDetail from 'components/legalPages/DetailsPages/ServiceGuaranteeDetail';
import DiscreetCannabisDeliveryDetail from 'components/legalPages/DetailsPages/DiscreetCannabisDeliveryDetail';
import PaymentsDetail from 'components/legalPages/DetailsPages/PaymentsDetail';
import LabTestingStandardsDetail from 'components/legalPages/DetailsPages/LabTestingStandardsDetail';
import SameDayDeliveryPageDetail from 'components/legalPages/DetailsPages/SameDayDeliveryPageDetail';

const LegalPageDetails = () => {
    const navigate = useNavigate()
    const { legalId = '' } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [linkState, setLinkState] = useState("")
    const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);
    const fullRoleTabheading = useMemo(() => searchParams.get('heading'), [searchParams]);
    const fullRoleTabSlug = useMemo(() => searchParams.get('slug'), [searchParams]);
    const { singleLegal } = useSelector((state => state.common));
    let localUser = getData('login-user-info')
    if (localUser) {
        localUser = JSON.parse(localUser)
    }

    const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
    const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

    const canCreate = hasSectionPermission(permissionsForMode, "Manage Website", "Create");
    const canEdit = hasSectionPermission(permissionsForMode, "Manage Website", "Edit/Update");
    const canView = hasSectionPermission(permissionsForMode, "Manage Website", "View Only");
    const canDelete = hasSectionPermission(permissionsForMode, "Manage Website", "Delete");


    useEffect(() => {
        setTimeout(() => {
            setLinkState("")
        }, 2000);
    }, [linkState])


    return (
        <CommonLayout>

            <Box pt={{ xs: 2, sm: 3, lg: 4 }} pl={{ xs: 2, sm: 3, lg: 4 }} pr={{ xs: 2, sm: 3, lg: 4 }} className="cannabinoids-tabs">
                <Box display="flex" alignItems="center" justifyContent={'space-between'}>
                    <Box display="flex" alignItems="center" color='text.main' lineHeight={1} mb={3.5}>
                        <div onClick={() => { navigate('/manages/static') }} style={{ cursor: 'pointer' }}><AngleRightIcon fontSize="14px" /></div>
                        <Typography variant='h6' fontWeight="semibold" ml={.75}>Static Pages</Typography>
                    </Box>
                    {
                        singleLegal?.slug &&
                        <Box
                            display="flex"
                            sx={{ cursor: 'pointer' }}
                            alignItems="center"
                            color="text.main"
                            lineHeight={1}
                            gap={2}
                            mb={3.5}
                            style={{ position: "relative" }}
                        >
                            <svg style={{ cursor: 'pointer' }} xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none" onClick={() => {
                                const link = `${fullRoleTab === "hemp" ? process.env.REACT_APP_HEMP_FRONTEND_URL : fullRoleTab === "stilo" ? process.env.REACT_APP_STILO_FRONTEND_URL : process.env.REACT_APP_HYPERWOLF_FRONTEND_URL}/${fullRoleTabSlug}`;

                                // const link = `${fullRoleTab === "hemp" ? process.env.REACT_APP_HEMP_FRONTEND_URL : process.env.REACT_APP_HYPERWOLF_FRONTEND_URL}/${fullRoleTabSlug}`;
                                navigator.clipboard.writeText(link)
                                    .then(() => setLinkState("Link copied!"))
                                    .catch(err => { });
                            }}>
                                <g clipPath="url(#clip0_14557_35992)">
                                    <path d="M8.61203 16.7513C6.65952 16.7513 5.07031 15.162 5.07031 13.2095V4.66797H3.61203C2.34784 4.66797 1.32031 5.69534 1.32031 6.95953V18.2095C1.32031 19.4737 2.34784 20.5013 3.61203 20.5013H14.0286C15.2928 20.5013 16.3203 19.4737 16.3203 18.2095V16.7513H8.61203Z" fill="#0163FF" />
                                    <path d="M19.6536 2.79172C19.6536 1.52585 18.6277 0.5 17.362 0.5H8.61203C7.34616 0.5 6.32031 1.52585 6.32031 2.79172V13.2083C6.32031 14.4742 7.34616 15.5 8.61203 15.5H17.362C18.6277 15.5 19.6536 14.4742 19.6536 13.2083V2.79172Z" fill="#0163FF" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_14557_35992">
                                        <rect width="20" height="20" fill="white" transform="translate(0.5 0.5)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            {
                                linkState &&
                                <p className="link-status">{linkState}</p>
                            }
                            <Typography
                                variant="body"
                                component="a"
                                href={`${fullRoleTab === "hemp" ? process.env.REACT_APP_HEMP_FRONTEND_URL : fullRoleTab === "stilo" ? process.env.REACT_APP_STILO_FRONTEND_URL : process.env.REACT_APP_HYPERWOLF_FRONTEND_URL}/${fullRoleTabSlug}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ textDecoration: 'none', color: 'inherit' }}
                                style={{
                                    borderRadius: "26px",
                                    color: "#0163FF",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    border: "1px solid #0163FF",
                                    padding: "10px 16px"
                                }}
                            >
                                {`${fullRoleTab === "hemp" ? process.env.REACT_APP_HEMP_FRONTEND_URL : fullRoleTab === "stilo" ? process.env.REACT_APP_STILO_FRONTEND_URL : process.env.REACT_APP_HYPERWOLF_FRONTEND_URL}/${fullRoleTabSlug}`}
                            </Typography>
                        </Box>
                    }
                </Box>
                {
                    // (legalId === 'career' || legalId === 'about_us' || legalId === 'meet_the_team') &&

                    <Box display="flex" alignItems="center" justifyContent={'space-between'}>

                        <Stack direction='row' gap={1} sx={{ background: '#ffffff' }} className="mb-0">
                            <Button className={fullRoleTab === 'hemp' ? 'active' : ''} onClick={() => {
                                setSearchParams({ roleTab: 'hemp', heading: fullRoleTabheading, slug: fullRoleTabSlug })
                            }} variant='outlined' sx={{ color: '#2E2E3A', minWidth: '160px' }}>
                                Hemp
                            </Button>
                            <Button onClick={() => {
                                setSearchParams({ roleTab: 'hyperwolf', heading: fullRoleTabheading, slug: fullRoleTabSlug })
                            }} variant='outlined' sx={{ color: '#2E2E3A', minWidth: '160px' }} className={fullRoleTab === 'hyperwolf' ? 'active' : ''} >
                                Hyperwolf
                            </Button>
                            <Button className={fullRoleTab === 'stilo' ? 'active' : ''}
                                onClick={() => {
                                    setSearchParams({ roleTab: 'stilo', heading: fullRoleTabheading, slug: fullRoleTabSlug })
                                }}
                                // onClick={() => { setSearchParams({ roleTab: 'stilo',heading:fullRoleTabheading }) }}
                                variant='outlined' sx={{ color: '#2E2E3A', minWidth: '160px' }}>
                                Stilo
                            </Button>
                        </Stack>
                        {
                            canEdit &&
                            <MDButton
                                sx={{ minWidth: '140px' }}
                                type='button'
                                variant='contained'
                                color='primary'
                                onClick={() => navigate(`/manages/static/edit/${legalId}?roleTab=${fullRoleTab}&heading=${fullRoleTabheading}&slug=${fullRoleTabSlug}`)}
                            >
                                {
                                    <>
                                        <div className="d-flex align-item-center text-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="24" fill="white">
                                                <path d="M0 0h24v24H0z" fill="none" />
                                                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                            </svg>
                                            <span className="ml-2">Edit</span>
                                        </div>
                                    </>
                                }
                                {/* {'+ Edit'} */}
                            </MDButton>
                        }
                    </Box>
                }
            </Box>

            {/* Slug base */}
            {
                legalId === 'career_template' ? <CareerDetail legalId={legalId} fullRoleTabSlug={fullRoleTabSlug} /> :
                    legalId === 'about_us_template' ? <AboutDetail legalId={legalId} fullRoleTabSlug={fullRoleTabSlug} /> :
                        legalId === 'meet_the_team_template' ? <TeamDetail legalId={legalId} fullRoleTabSlug={fullRoleTabSlug} /> :
                            legalId === 'review_template' ? <ReviewDetail legalId={legalId} fullRoleTabSlug={fullRoleTabSlug} /> :
                                legalId === 'pricing_template' ? <PricingDetail legalId={legalId} fullRoleTabSlug={fullRoleTabSlug} /> :
                                legalId === 'zipcode_template' ? <ZipcodePageDetail legalId={legalId} fullRoleTabSlug={fullRoleTabSlug} /> :
                                legalId === 'delivery_template' ? <DeliveryTimeDetail legalId={legalId} fullRoleTabSlug={fullRoleTabSlug} /> :
                                legalId === 'service_guarantee' ? <ServiceGuaranteeDetail legalId={legalId} fullRoleTabSlug={fullRoleTabSlug} /> :
                                legalId === 'discreet_cannabis_delivery' ? <DiscreetCannabisDeliveryDetail legalId={legalId} fullRoleTabSlug={fullRoleTabSlug} /> :
                                legalId === 'payments' ? <PaymentsDetail legalId={legalId} fullRoleTabSlug={fullRoleTabSlug} /> :
                                legalId === 'lab_testing_standards' ? <LabTestingStandardsDetail legalId={legalId} fullRoleTabSlug={fullRoleTabSlug} /> :
                                legalId === 'same_day_delivery' ? <SameDayDeliveryPageDetail legalId={legalId} fullRoleTabSlug={fullRoleTabSlug} /> :

                                <EditLegalPagesDetails legalId={legalId} fullRoleTabSlug={fullRoleTabSlug} />
            }
        </CommonLayout>
    )
}

export default LegalPageDetails
